export default __webpack_public_path__ + "static/media/4.9acbe61a.png";